import {Directive, ElementRef, Inject} from '@angular/core';

@Directive({
  standalone: false,
  selector: '[appBringozPpi]'
})
export class BringozPpiDirective {
  constructor(@Inject(ElementRef) private elementRef: ElementRef) {
    this.elementRef.nativeElement.setAttribute('data-sl', 'mask');
  }
}
